import Tone from 'tone';

const name = 'QmcdpaZe62u6p47s2Nmi7jYLpgTbmz6MxVnwvndNFi53Sf'; //convolver/PrimeXtraLong.wav';

class SampleRateChooser {
    constructor() {
        this.DEFAULT_BUFFER = new Tone.Buffer(window.installation ? '/public' + name : name);
    }

    setSampleRate(rate, latencyHint='interactive') {
	console.log('setSampleRate =', rate);
	if (rate === 44100) {
	    return;
	}
        Tone.setContext(new AudioContext({
            sampleRate: rate,
            latencyHint: latencyHint
        }));
        window.context = Tone.Master.context;
        console.log(Tone.Master.context);
        this.DEFAULT_BUFFER = new Tone.Buffer(window.installation ? '/public' + name : name);
    }
}

const sampleRateChooser = new SampleRateChooser();
export default sampleRateChooser;
